import React from "react";
import { Button } from "react-bootstrap";
import axios from "axios";

function DownloadManifestCsv(props) {
  const downloadCsv = async () => {
    let date = new Date();
    await axios
      .get(
        `api/v1/hwts/search/manifest/id/csv?ManifestId=${props.MANIFEST_ID}&versionNo=${props.COPY_TYPE_IND}`
      )
      .then((res) => {
        let date = new Date();
        let filename = `${props.MANIFEST_ID}_${date.toLocaleDateString(
          "en-US"
        )}.csv`;
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          //IE11 and the legacy version Edge support
          let blob = new Blob([res.data], {
            type: "csv",
          });
          window.navigator.msSaveOrOpenBlob(blob, filename);
        } else {
          // other browsers
          var bl = new Blob([res.data], {
            type: "csv",
          });
          var a = document.createElement("a");
          a.href = URL.createObjectURL(bl);
          a.download = filename;
          a.hidden = true;
          document.body.appendChild(a);
          a.click();
        }
      });
  };
  return (
    <Button
      disabled={props.isFetching}
      size="sm"
      variant="dark"
      onClick={() => downloadCsv()}
    >
      Export CSV
    </Button>
  );
}

export default DownloadManifestCsv;
